<template>
  <section>
    <button
      type="button"
      class="flex items-center w-full shadow border-1 border-borderColor rounded-lg h-12 px-6 font-semibold lg:text-sm xl:text-base 3xl:text-lg "
      :class="[classStr ? classStr : 'justify-center bg-gray-lightest']"
      @click.prevent="loginWithGoogle"
    >
      <GoogleIcon />
      <span
        class="ml-2"
        :class="[classStr ? 'text-white': 'text-blackgreylight']"
        >{{$route.path && $route.path === '/login' ? 'Login with Google' : 'Get started with Google'}}</span
      >
    </button>
  </section>
</template>

<script>
import { GoogleIcon } from "@/components/icons";
import { mapActions } from "vuex";
import store from "@/store";

export default {
  name: "GoogleLogin",
  components: {
    GoogleIcon,
  },
  props: {
    isGuest: {
      type: Boolean,
      default: false,
    },
    user_type: {
      type: Number,
      default: 1,
    },
    classStr: {
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(["getCallback", "postOauth"]),

    async loginWithGoogle() {
      const client = await google.accounts.oauth2.initCodeClient({
        client_id: window.config.VUE_APP_GOOGLE_CLIENT_ID,
        scope: "profile email https://www.googleapis.com/auth/calendar",
        ux_mode: "popup",
        callback: (response) => {
          const payload = {
            token: response.code,
            isGuest: this.isGuest,
            user_type: this.user_type,
          };
          this.getCallback(payload).then(() => {
            this.$emit("onLogin", this.getUser());
          });
        },
      });
      client && client.requestCode();
    },
  },
};
</script>